import * as React from "react";
const SvgHeart = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M3.464 5.464a5 5 0 0 1 7.072 0L12 6.93l1.464-1.464a5 5 0 0 1 7.071 7.07l-8.005 8.006a.75.75 0 0 1-1.06 0l-8.006-8.005a5 5 0 0 1 0-7.072Zm6.01 1.061a3.5 3.5 0 1 0-4.949 4.95L12 18.95l7.474-7.475a3.5 3.5 0 0 0-4.95-4.95L12 9.05 9.475 6.525Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgHeart;
